<template>
    <div :ref="stepName" style="position:relative">
        <div class="form-header gender-header">
            <p style="font-size:21px;">Découvrez Testachats pendant 2 mois pour 2 € Résiliable à tout moment !</p>
            <span>Et choisissez votre cadeau de bienvenue parmi des dizaines de marques. </span>
        </div>
        <GenderForm></GenderForm>
        <!--<div ref="block" style="width: 100px;height: 100px;background:red;"></div>-->
        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import {Button} from "../../../../../../models/fields/Button";
import GenderForm from "./GenderForm";
import {gsap} from "gsap";
import {sync} from "vuex-pathify";
import store from "../../../../../../store";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: {GenderForm},
    mixins: [mixin, animation_engine_mixin, animation_step_style_mixin],
}
</script>
